import {BehaviorSubject, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {Store} from '@ngxs/store';
import {GetOwnGeneticStatus} from '../../states/dashboard-genetics-retrieve/dashboard-genetics-retrieve.actions';
import {AuthState} from '../../../auth/states/auth/auth.state';
import {WINDOW} from '../../../universal/window/window.service';
import {DashboardGeneticsRetrieveState} from '../../states/dashboard-genetics-retrieve/dashboard-genetics-retrieve.state';
import {DashboardBrainPartsStateQueries} from '../../../dashboard-brain-parts/states/dashboard-brain-parts/dashboard-brain-parts.state';
import {RegionsCarouselRootComponent} from '../../../dashboard-shared/containers/regions-carousel-root/regions-carousel-root.component';
import {NgClass, NgStyle} from '@angular/common';
import {DashboardGeneticsChartComponent} from '../dashboard-genetics-chart/dashboard-genetics-chart.component';
import {DashboardViewerDataZoneGeneticsComponent} from '../../../dashboard-viewer-data-zone/components/dashboard-viewer-data-zone-genetics/dashboard-viewer-data-zone-genetics.component';
import {RtElementResizedDirective} from '../../../rt-element-resized/rt-element-resized.directive';

@Component({
  selector: 'app-dashboard-genetics-single-view',
  templateUrl: './dashboard-genetics-single-view.component.html',
  styleUrls: ['./dashboard-genetics-single-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RtElementResizedDirective,
    RegionsCarouselRootComponent,
    NgStyle,
    DashboardGeneticsChartComponent,
    DashboardViewerDataZoneGeneticsComponent,
    NgClass,
  ],
})
export class DashboardGeneticsSingleViewComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class') classList = ['height-100-percents'];
  @ViewChild('geneticContent') geneticContent: ElementRef;

  public readonly mostActualOwnStatus$ = this.store.select(DashboardGeneticsRetrieveState.mostActualOwnStatus);
  public readonly brainPartList$ = this.store.select(DashboardBrainPartsStateQueries.brainPartList);
  public readonly user$ = this.store.select(AuthState.getUser);

  /** Contain genetic viewer height. */
  public geneticContentHeight = 300;

  /** Contain genetic viewer width. */
  public geneticContentWidth = 300;

  /** Contain window inner width. */
  public windowInnerWidth = 1280;

  /** Indicates whether the swipe block open. */
  public isSwipeBlockOpened = false;

  /** Stream that triggers scroll to the provided item on each emit. */
  public readonly carouselScrollManagerByName$ = new BehaviorSubject<string>('Hippocampus');

  /** Component subscriptions. Will be unsubscribed on destroy. */
  private readonly subscription = new Subscription();

  constructor(private store: Store, @Inject(WINDOW) private window: Window) {}

  @HostListener('window:resize', [])
  windowResized(): void {
    this.windowInnerWidth = this.window.innerWidth;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.user$.pipe(filter(user => !!user)).subscribe(() => {
        this.store.dispatch([new GetOwnGeneticStatus()]);
      })
    );
  }

  ngAfterViewInit(): void {
    this.windowResized();
    this.chartContentResized();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onSwipe(event: {angle: number}): void {
    this.isSwipeBlockOpened = event.angle <= 0;
  }

  public chartContentResized(): void {
    this.geneticContentHeight = this.geneticContent.nativeElement.getBoundingClientRect().height;
    this.geneticContentWidth = this.geneticContent.nativeElement.getBoundingClientRect().width;
  }
}
